import * as tslib_1 from "tslib";
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
export default (function (props) {
  return React.createElement(FormattedMessage, tslib_1.__assign({}, props), function (translatedString) {
    return translatedString;
  });
});